import { Component } from "react";

class Spinner extends Component {
    render() {
        return(
            <svg width="204px" height="204px" display="block" shapeRendering="auto" style={{background: "rgb(255, 255, 255)", margin: "0 auto"}} preserveAspectRatio="xMidYMid" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <g transform="rotate(0 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-1.45748987854251s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(18.947 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-1.376518218623482s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(37.895 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-1.2955465587044535s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(56.842 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-1.2145748987854252s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(75.789 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-1.1336032388663968s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(94.737 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-1.0526315789473684s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(113.68 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-0.9716599190283401s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(132.63 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-0.8906882591093118s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(151.58 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-0.8097165991902834s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(170.53 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-0.728744939271255s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(189.47 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-0.6477732793522267s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(208.42 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-0.5668016194331984s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(227.37 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-0.4858299595141701s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(246.32 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-0.4048582995951417s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(265.26 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-0.32388663967611336s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(-75.789 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-0.24291497975708504s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(-56.842 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-0.16194331983805668s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(-37.895 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="-0.08097165991902834s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
                <g transform="rotate(-18.947 50 50)">
                <rect x="49.5" y="28" width="1" height="8" rx="0" ry="0" fill="#9f0013">
                <animate attributeName="opacity" begin="0s" dur="1.5384615384615383s" keyTimes="0;1" repeatCount="indefinite" values="1;0"/>
                </rect>
                </g>
            </svg>
        )
    }
}

export default Spinner